import React, { Fragment } from "react"
import { Typography, useTheme } from "@material-ui/core"
import PropTypes from "prop-types"

//a react funtional component that displays the number of characters left in the textarea
const CharacterCounter = ({ typingLength, maxLength = 1000 }) => {
  const theme = useTheme()

  return (
    <Fragment>
      <Typography>
        <span
          style={
            typingLength > maxLength
              ? { color: theme.palette.error.main }
              : { color: theme.palette.success.main }
          }
        >
          {typingLength}
        </span>/{maxLength}
      </Typography>
    </Fragment>
  )
}

CharacterCounter.propTypes = {
  typingLength: PropTypes.number,
  maxLength: PropTypes.number,
}

export default CharacterCounter
